<template>
  <div class="home">
    <p>Hello !</p>
    <p>This is a side project made using gridstack & vue3 :D</p>
  </div>
</template>

<script>
export default {
  name: "Home",
};
</script>

<style scoped>
.home {
  width: 900px;
  height: 70vh;
  margin: 0 auto;
}
</style>
